import { siteId } from '../../config';
import { createResourceRequests } from '../../helpers/resource';
import * as normalizers from './normalizers';

const newSession = () => ({
  method: 'GET',
  url: `track/${siteId}/newsession`,
  normalizer: normalizers.fromNewSession,
});

const viewTicket = props => ({
  method: 'POST',
  url: `track/${siteId}/viewticket`,
  data: normalizers.toViewTicket(props),
});

const buyTicket = props => ({
  method: 'POST',
  url: `track/${siteId}/buyticket`,
  data: normalizers.toBuyTicket(props),
  rootData: props,
});

const recordAction = props => ({
  method: 'POST',
  url: `track/${siteId}/action`,
  data: normalizers.toAction(props),
});

const endpoints = {
  newSession,
  viewTicket,
  buyTicket,
  recordAction,
};

const api = createResourceRequests(endpoints);

export default api;



// WEBPACK FOOTER //
// ./src/resources/analytics/api.js